/**
 * @author Kelnik
 *
 * SliderArrows - Стрелки для переключниея слайдера по таймингу
 */


class SliderArrows {
    constructor(options) {
        this.options = options;
        this.container = options.container;
        this.prevSelector = '.j-slider-arrows-prev';
        this.nextSelector = '.j-slider-arrows-next';

        this.duration = options.duration || 7000;
        this.resumeTime = options.resumeTime || 5000;
    }

    init() {
        this._initElements();
        this.startTimer();
        this._bindEvents();
    }

    _initElements() {
        this.prev = this.container.querySelector(this.prevSelector);
        this.next = this.container.querySelector(this.nextSelector);
    }

    startTimer() {
        this.container.classList.add('is-animate');

        if (this.options.timeout) {
            this.timer = setInterval(this.options.timeout.bind(this), this.duration);
        }
    }

    _bindEvents() {
        this.prev.addEventListener('click', this.stopTimer.bind(this));
        this.next.addEventListener('click', this.stopTimer.bind(this));
    }

    stopTimer() {
        clearInterval(this.timer);
        this.container.classList.remove('is-animate');

        this.resumeTimer();
    }

    resumeTimer() {
        clearTimeout(this.timerResume);

        this.timerResume = setTimeout(() => {
            this.startTimer();
        }, this.resumeTime);
    }
}

export default SliderArrows;
